export default __webpack_public_path__ + "static/media/leventkaptan5.af72f83a.jpg";